module.exports = __webpack_public_path__ + "img/mcredit.19b7b252.png";